import { useLayoutEffect, useSyncExternalStore } from "react";

// Whether AppUpdateBanner is on screen right now. The install banner reads it
// to yield: one bottom bar at a time, the update bar first. Same shape as
// offline-chip-claim. See [[app-update-banner.spec]] and
// [[install-app-banner.spec]] § Precedence over the update bar.

let showing = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function set(next: boolean) {
  if (showing === next) return;
  showing = next;
  for (const listener of listeners) listener();
}

/**
 * Publishes the update banner's visibility for as long as the caller is
 * mounted. A layout effect, so a sibling that yields to it does so before the
 * first paint rather than flashing for a frame.
 */
export function usePublishUpdateBannerVisible(visible: boolean): void {
  useLayoutEffect(() => {
    set(visible);
    return () => set(false);
  }, [visible]);
}

export function useUpdateBannerVisible(): boolean {
  return useSyncExternalStore(subscribe, () => showing);
}
